/**
 * RFC 5321 practical maximum length of an email address; matches the backend
 * `@IsEmail()` (validator.js) limit and Angular's own `EMAIL_REGEXP` cap.
 * Shared by every email input's `maxlength` attribute + `Validators.maxLength`
 * (#2122 / #2129).
 */
export const MAX_EMAIL_LENGTH = 254;

export interface CreateEmailI {
  id?: string;
  date: string;
  emailSubject: string;
  emailMessage: string;
}

export interface EmailI {
  emailContent: string;
  emailSubject: string;
  emailTo: string;
}
export interface EmailResponseI {
  id: string;
}

export interface SendGridTemplateVersionI {
  id: string;
  name: string;
  subject: string;
  active?: number;
  html_content?: string;
  plain_content?: string;
}

export interface SendGridTemplateI {
  id: string;
  name: string;
  generation?: string;
  updated_at?: string;
  versions?: SendGridTemplateVersionI[];
}

export interface EmailRecipientI {
  email: string;
  firstName: string;
  lastName: string;
  bookingId?: string;
}

export enum SendToFilterEnum {
  CONFIRMED = 'confirmed',
  ALL = 'all',
}

export interface EmailAllRequestI {
  templateId: string;
  emailContent?: string;
  subject?: string;
  dryRun?: boolean;
  sendTo?: SendToFilterEnum;
  additionalTemplateData?: Record<string, unknown>;
}

export interface EmailAllResponseI {
  recipientCount: number;
  recipients?: EmailRecipientI[];
  jobId?: string;
  success: boolean;
  message?: string;
  successCount?: number;
  failureCount?: number;
}
